export const TITLE_FIELD_KEY = 'title'
export const CONTENT_FIELD_KEY = 'content'
export const COMMENT_REPLY_TYPE_SLUG = 'comment'
